function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { COLLABORATE_EXTERNAL_KEYS, SUBSCRIPTION_TYPES, SUBSCRIPTION_STATUS } from './const';
export const isPaidSubscription = (subscription, subscriptions) => subscriptions.some(current => !!current.offeringName && current.offeringName === subscription.offeringName && current.status === SUBSCRIPTION_STATUS.ACTIVE && current.type !== SUBSCRIPTION_TYPES.TRIAL);
const camelize = str => {
  return str.toLowerCase().replace(/[^a-z\d]+(.)/gi, (m, chr) => chr.toUpperCase());
};
const generateProductName = trial => {
  const productName = 'offeringCategoryName' in trial ? trial.offeringCategoryName : trial.offeringName;
  if ('offeringCategory' in trial && trial.offeringExternalKey === COLLABORATE_EXTERNAL_KEYS.COLLABORATE_PRO) {
    return productName + ' Pro';
  }
  return productName;
};
const reducer = (result, trial, index) => {
  result.trialsDisplayed = "".concat(result.trialsDisplayed).concat(index !== 0 ? ', ' : '').concat(generateProductName(trial));
  result["".concat(camelize(generateProductName(trial)), "TrialDaysRemaining")] = trial.daysRemaining;
  return result;
};
const generateTrialsTrackingData = trials => {
  return trials.reduce(reducer, {
    trialsDisplayed: ''
  });
};
export const getTrackingProperties = (user, trials, currentProductId) => _objectSpread({
  modalOpenTimeStamp: new Date(Date.now()).toISOString(),
  currentPage: currentProductId,
  currentUserEmailDomain: user && user.email.substring(user.email.lastIndexOf('@') + 1)
}, generateTrialsTrackingData(trials));
export const addDaysToDate = (date, days) => {
  const result = new Date(date);
  return result.setDate(result.getDate() + days);
};
export const shouldShowExpiredMessage = trials => {
  const lastTrialExpired = trials.reduce((result, trial) => {
    if (result) {
      return new Date(result.endDate) < new Date(trial.endDate) ? trial : result;
    }
    return trial;
  });
  const trialBannerHideDate = addDaysToDate(new Date(lastTrialExpired.endDate), 1);
  const today = new Date(Date.now()).setHours(0, 0, 0, 0);
  return today <= trialBannerHideDate;
};
//# sourceMappingURL=utils.js.map